import request from '../utils'

const selectionApi = {
    selectionList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/selection`)
        const res = await req;
        return res.body;
    }, 
    selectionDetail: async (modelingId, selection) => {
        const req = request.get(`/api/modeling/${modelingId}/selection/${selection}`)
        const res = await req;
        return res.body;
    },
    selectionUpdate: async (modelingId, selection) => {
        const req = request.put(`/api/modeling/${modelingId}/selection/${selection.id}`).send(selection);
        const res = await req;
        return res.body;
    },
    selectionCreate: async (modelingId, selection) => {
        const req = request.post(`/api/modeling/${modelingId}/selection`).send(selection);
        const res = await req;
        return res.body;
    },
    selectionDelete: async (modelingId, selectionId) => {
        const req = request.delete(`/api/modeling/${modelingId}/selection/${selectionId}`);
        await req;
    }
};

export default selectionApi